import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowStat = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 11,
	viewBox: "0 0 12 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2812 5.95703C11.5352 5.72852 11.5352 5.32227 11.3066 5.09375C11.0781 4.83984 10.6719 4.83984 10.4434 5.06836L5.97461 9.33398L1.53125 5.06836C1.30273 4.83984 0.896484 4.83984 0.667969 5.09375C0.439453 5.32227 0.439453 5.72852 0.693359 5.95703L5.56836 10.6289C5.69531 10.7305 5.84766 10.7812 5.97461 10.7812C6.12695 10.7812 6.2793 10.7305 6.40625 10.6289L11.2812 5.95703Z",
			fill: "#78909C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0.75C0 0.335786 0.335786 0 0.75 0H11.25C11.6642 0 12 0.335786 12 0.75C12 1.16421 11.6642 1.5 11.25 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75Z",
			fill: "#78909C"
		})
	]
});
const ForwardRef = forwardRef(SvgArrowStat);
export { ForwardRef as ReactComponent };
